(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function playGridVideos(root) {
      (root || document).querySelectorAll('.card-gallery video').forEach(function (video) {
        video.muted = true;
        video.loop = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(function () {});
        }
      });
    }

    if (document.readyState !== 'loading') {
      playGridVideos(document);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        playGridVideos(document);
      });
    }

    // Handle videos added later (infinite scroll / filtering).
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('.card-gallery')) {
              playGridVideos(node);
            } else if (node.querySelector && node.querySelector('.card-gallery video')) {
              playGridVideos(node);
            }
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
